import _ from 'lodash'
import queryString from 'query-string'

const helper = {
  snakeToCamelCaseCollection: (coll) => {
    const d = {}
    Object.keys(coll).forEach(k => { d[_.camelCase(k)] = coll[k] })
    return d
  },

  camelCaseToSnakeCollection: (coll) => {
    const d = {}
    Object.keys(coll).forEach(k => { d[_.snakeCase(k)] = coll[k] })
    return d
  },

  debounce: (func, wait, immediate) => {
    let timeout
    return function () {
      const context = this
      const args = arguments
      const later = () => {
        timeout = null
        if (!immediate) {
          func.apply(context, args)
        }
      }
      const callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) {
        func.apply(context, args)
      }
    }
  },

  validateEmail: email => {
    const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    return emailPattern.test(email)
  },

  forwardClientQueryStringToPath: (path, query) => {
    const params = queryString.parse(query)
    const clientIdQS = params.clientId ? `?clientId=${params.clientId}` : ''
    const returnQS = params.clientId && params.return ? `&return=${params.return}` : ''

    return `${path}${clientIdQS}${returnQS}`
  }
}

export default helper
